export const api = "https://mnfy.herokuapp.com/api";
// export const api = "http://localhost:5000/api";
